// extracted by mini-css-extract-plugin
module.exports = {"table":"SyncJbcSettingForm__table--3HAw5 m-table-list"};